import React, { useState } from "react";
import { Menu, MenuItem, useMediaQuery, useTheme } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import {
  StyledMenuButton,
  StyledSelectedLabel,
  StyledTab,
  StyledTabs,
  StyledTabsWrapper,
} from "./style";

export default function OrderTabs({
  tabLabels,
  selectedTab,
  setSelectedTab,
  responsiveMode = false,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(
    theme.breakpoints.down("sm")
  );

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleMenuSelect = (index) => {
    setSelectedTab(index);
    handleMenuClose();
  };

  return (
    <StyledTabsWrapper
      tabLabel={tabLabels[selectedTab]}
      responsiveMode={responsiveMode}
    >
      {isMobile ? (
        <>
          <StyledMenuButton onClick={handleMenuOpen}>
            <MenuIcon />
            <StyledSelectedLabel>{tabLabels[selectedTab]}</StyledSelectedLabel>
          </StyledMenuButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            {tabLabels.map((label, index) => (
              <MenuItem
                key={label}
                selected={index === selectedTab}
                onClick={() => handleMenuSelect(index)}
              >
                {label}
              </MenuItem>
            ))}
          </Menu>
        </>
      ) : (
        <StyledTabs
          value={selectedTab}
          onChange={(_, newVal) => setSelectedTab(newVal)}
          variant={responsiveMode ? "scrollable" : "standard"}
          scrollButtons={responsiveMode ? "auto" : false}
          allowScrollButtonsMobile={responsiveMode}
          responsiveMode={responsiveMode}
        >
          {tabLabels.map((label, index) => (
            <StyledTab
              key={index}
              label={label}
              tabLabel={label}
              responsiveMode={responsiveMode}
            />
          ))}
        </StyledTabs>
      )}
    </StyledTabsWrapper>
  );
}
